export default __webpack_public_path__ + "static/in-w2-amazon-main-diagram-en6-fa269d493a9c4460c6fd082ddadf4c0c.webp";